function preventDefault(e) {
  e.preventDefault();
}

function preventScrollKeys(e) {
  const keys = [32, 37, 38, 39, 40];
  if (keys.includes(e.keyCode)) {
    e.preventDefault();
  }
}

function disableScroll() {
  document.body.style.overflow = "hidden";
  window.addEventListener("wheel", preventDefault, { passive: false });
  window.addEventListener("touchmove", preventDefault, { passive: false });
  window.addEventListener("keydown", preventScrollKeys);
}

export default disableScroll;
export { preventDefault, preventScrollKeys };
